export default __webpack_public_path__ + "static/j-unit-45473b821e76dcedb49e38e518012d42.svg";